import { render, staticRenderFns } from "./edit-user-modal.vue?vue&type=template&id=ef6cb50e&scoped=true"
import script from "./edit-user-modal.vue?vue&type=script&lang=js"
export * from "./edit-user-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-user-modal.vue?vue&type=style&index=0&id=ef6cb50e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6cb50e",
  null
  
)

export default component.exports